import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function RadioWidget(props) {
  var options = props.options,
    value = props.value,
    required = props.required,
    disabled = props.disabled,
    readonly = props.readonly,
    autofocus = props.autofocus,
    _onChange = props.onChange;
  // Generating a unique field name to identify this set of radio buttons
  var name = Math.random().toString();
  var enumOptions = options.enumOptions,
    inline = options.inline;
  // checked={checked} has been moved above name={name}, As mentioned in #349;
  // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.
  return /*#__PURE__*/_jsx("div", {
    className: "form-check field-radio-group",
    children: enumOptions.map(function (option, i) {
      var checked = option.value === value;
      var disabledCls = disabled || readonly ? "disabled" : "";
      var radio = /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("input", {
          type: "radio",
          checked: checked,
          name: name,
          required: required,
          value: option.value,
          disabled: disabled || readonly,
          autoFocus: autofocus && i === 0,
          onChange: function onChange(_) {
            return _onChange(option.value);
          }
        }), /*#__PURE__*/_jsx("span", {
          children: option.label
        })]
      });
      return inline ? /*#__PURE__*/_jsx("label", {
        className: "radio-inline ".concat(disabledCls),
        children: radio
      }, i) : /*#__PURE__*/_jsx("div", {
        onClick: function onClick() {
          return _onChange(option.value);
        },
        className: "radio ".concat(disabledCls, " ").concat(checked ? "selected" : ""),
        children: /*#__PURE__*/_jsx("label", {
          children: radio
        })
      }, i);
    })
  });
}
export default RadioWidget;
//# sourceMappingURL=RadioWidget.js.map